var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFivePlusDonationsUnlocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{stroke:#8d0034;stroke-linecap:round;stroke-width:3px;fill:url(#a);}.b{fill:none;}.c{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 2.5,
    y1: 50,
    x2: 97.5,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d11947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d0034"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 50,
    cy: 50,
    r: 47.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M41.48,37.13a2.5,2.5,0,0,0-2.19,2.44c0,1,.4,1.77,2.19,2.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M47.18,49.2c0-1.17-.41-1.91-2.61-2.71v5.63A3.06,3.06,0,0,0,47.18,49.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M44,66.71a20.73,20.73,0,0,0,12.17-3.92,1.5,1.5,0,1,0-1.75-2.44A17.69,17.69,0,0,1,44,63.71,17.86,17.86,0,1,1,57.33,34a1.5,1.5,0,0,0,2.25-2A20.86,20.86,0,1,0,44,66.71Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M43.23,59.11h1.59a.75.75,0,0,0,.75-.75V56.12c3.42-.48,5.82-2.91,5.82-6s-1.52-4.64-5.61-6l-.21-.07V38.3a5.29,5.29,0,0,1,2.62,2,.75.75,0,0,0,.49.32.79.79,0,0,0,.58-.14l1.35-1a.76.76,0,0,0,.17-1,8.21,8.21,0,0,0-5.21-3.27V33.34a.74.74,0,0,0-.75-.75H43.23a.75.75,0,0,0-.75.75v1.81c-3.19.45-5.37,2.68-5.37,5.6,0,2.69,1.68,4.5,5.28,5.68l.09,0v6.62a6.38,6.38,0,0,1-3.39-2.21A.75.75,0,0,0,38,50.79l-1.26,1.05a.76.76,0,0,0-.1,1,9.19,9.19,0,0,0,5.8,3.19v2.28A.76.76,0,0,0,43.23,59.11Zm2.34-11.62c2.2.8,2.61,1.54,2.61,2.71a3.06,3.06,0,0,1-2.61,2.92Zm-5.28-6.92a2.5,2.5,0,0,1,2.19-2.44v4.94C40.69,42.34,40.29,41.53,40.29,40.57Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M58.29,38.78,57.18,47.9a.67.67,0,0,0,.4.69l1.27.52a.65.65,0,0,0,.72-.14,5.31,5.31,0,0,1,3.84-1.55,3.93,3.93,0,0,1,4.25,4,4.33,4.33,0,0,1-8.54.81.71.71,0,0,0-.28-.43.68.68,0,0,0-.5-.1L56.81,52a.64.64,0,0,0-.42.28.61.61,0,0,0-.1.49,6.78,6.78,0,0,0,7,5.51c4.21,0,7.26-2.92,7.26-6.93a6.58,6.58,0,0,0-6.94-6.65,8,8,0,0,0-3.3.68l.5-4.46h8a.67.67,0,0,0,.66-.66V38.86a.67.67,0,0,0-.66-.66H58.94A.66.66,0,0,0,58.29,38.78Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M83.35,46.52h-4V42.43a.66.66,0,0,0-.66-.66H77.22a.66.66,0,0,0-.66.66v4.09h-4a.67.67,0,0,0-.66.66v1.43a.66.66,0,0,0,.66.66h4v4.18a.67.67,0,0,0,.66.66h1.43a.67.67,0,0,0,.66-.66V49.27h4a.65.65,0,0,0,.66-.66V47.18A.66.66,0,0,0,83.35,46.52Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M76,63.45H60.48a1.5,1.5,0,0,0,0,3H76a3,3,0,0,1,0,6H22a3,3,0,0,1,0-6h4.5a1.5,1.5,0,1,0,0-3H22a6,6,0,0,0,0,12H76a6,6,0,0,0,0-12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFivePlusDonationsUnlocked);
export default __webpack_public_path__ + "static/media/fivePlusDonationsUnlocked.861b7fc9e7ba0a349710a1d3e378e2f9.svg";
export { ForwardRef as ReactComponent };